// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2kWCo","header":"Messages_header__v158K"};